
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface MobileMenuGuestContentProps {
  onLinkClick: () => void;
}

const MobileMenuGuestContent = ({ onLinkClick }: MobileMenuGuestContentProps) => {
  const { t } = useTranslation('common');
  
  return (
    <div className="flex flex-col gap-4 pt-4">
      <Link to="/auth?tab=login" onClick={onLinkClick}>
        <Button variant="outline" className="w-full">{t("navigation.login")}</Button>
      </Link>
      <Link to="/auth?tab=signup" onClick={onLinkClick}>
        <Button className="w-full">{t("navigation.signup")}</Button>
      </Link>
    </div>
  );
};

export default MobileMenuGuestContent;
